module.exports = __webpack_public_path__ + "img/programs.d08a5b41.svg";